import React from "react";
import { Container, Image, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import partImage from "../Assets/Image/nonferrousmachined01.jpg";
import fabricatedcopper from "../Assets/Image/fabricatedcopper1.jpg";
import bimetallic from "../Assets/Image/bimetallic1.jpg";
import copper1 from "../Assets/Image/nonferrous.jpg";
import stampedNonferrous from "../Assets/Image/stampedNonferrous01.jpg";
import { Helmet } from "react-helmet";

const relatedProducts = [
  {
    name: "Machined and Silver Brazed parts",
    description: "Engineered busbars for reliable power distribution.",
    image: fabricatedcopper,
  },
  {
    name: "Deep Boring and Slitting Components",
    description:
      "Ideal for joining dissimilar metals in critical applications.",
    image: bimetallic,
  },
  {
    name: "Copper Turned components",
    description: "Flexible copper connectors for dynamic environments.",
    image: copper1,
  },
  {
    name: "Grinded and Coated Copper components",
    description: "Custom stamped non-ferrous parts for various industries.",
    image: stampedNonferrous,
  },
];

const NonFerrousMachinedParts = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Non Ferrous Machined Parts | Delta Engineering</title>
        <meta
          name="description"
          content="Precision-engineered non-ferrous machined parts made from copper, aluminum, brass, and bronze. High conductivity, corrosion resistance, and CNC machining for industrial applications."
        />
        <meta
          name="keywords"
          content="Non Ferrous Machined Parts, Copper Machined Components, Brass Machined Parts, Aluminum Machined Parts, Bronze Machined Parts, CNC Machining, Electrical Components, Telecom Machined Parts, Automotive Copper Components"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Non Ferrous Machined Parts" />
        <meta
          property="og:description"
          content="Custom machined components from copper, brass, aluminum, and bronze with CNC precision. Ideal for switchgear, transformers, telecom, automotive, and industrial automation applications."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/non-ferrous-machined-parts"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/non-ferrous-machined-parts.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Non Ferrous Machined Parts" />
        <meta
          name="twitter:description"
          content="High-performance non-ferrous machined parts crafted with precision CNC turning, milling, and drilling. Manufactured using copper, brass, aluminum, and bronze for maximum reliability."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/non-ferrous-machined-parts.jpg"
        />
      </Helmet>

      <section className="productbanner1 d-flex align-items-center position-relative ">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">

          <Row className="justify-content-center">
            <Col lg={8} className="hero-content text-center">
              <h2
                className="hero-title"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
               <span className="blue-text"> Non Ferrous </span>{" "}
            <span className="white-text">Machined Parts</span>
              </h2>
              <p
                className="hero-subtitle"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                Precision engineered components made from aluminum, brass,
                copper, and bronze for high-performance applications.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <div
        className="copper-laminated-section py-3"
        style={{ position: "relative" }}
      >
        <Button onClick={() => navigate("/ourproducts")} className="back-btn">
          <IoMdArrowRoundBack className="back-icon" />
          Back
        </Button>
        <Container>
          <Row className="text-center mb-1">
            <Col>
              <h3 className="fw-bold section-title">
                Non Ferrous Machined Parts{" "}
                <span className="title-underline"></span>
              </h3>
              <p className="text-muted text-center mb-5">
                Precision engineering of aluminum, brass, copper & bronze
                components for high-performance industrial applications.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <Container className="py-5">
        <Row className="align-items-center mb-5">
          <Col md={6}>
            <Image
              src={partImage}
              alt="Non Ferrous Machined Parts"
              fluid
              style={{
                maxHeight: "300px",
                width: "500px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
          </Col>
          <Col md={6}>
            <h3 className="mb-3 fw-bold">Overview</h3>
            <p>
              Our Non-Ferrous Machined Parts are crafted with high precision
              using a wide range of metals such as copper, aluminum, brass.
              These parts are widely used across all electrical industries where
              high conductivity, corrosion resistance, and dimensional accuracy
              are crucial.
            </p>
            <p>
              Whether it's for electrical systems, telecom infrastructure,
              automotive applications, or mechanical assemblies — our machining
              capabilities ensure durability and performance with tight
              tolerance levels.
            </p>
          </Col>
        </Row>

        <Row className="mb-5">
          <Col>
            <h4>Key Features & Benefits:</h4>
            <ul>
              <li>
                Surface treated machined components , Tin / Silver/ Nickel
                Plating
              </li>
              <li>High dimensional accuracy and fine surface finish</li>
              <li>
                Custom-built to client specifications or technical drawings
              </li>
              <li>Excellent electrical conductivity</li>
              <li>Manufactured using CNC turning, milling, and drilling</li>
            </ul>
          </Col>
        </Row>

        <Row className="mb-5">
          <Col>
            <h4>Materials We Work With:</h4>
            <ul>
              <li>
                <strong>Copper:</strong> ETP, Oxygen Free (OFHC), Electrolytic
                Copper
              </li>
              <li>
                <strong>Brass:</strong> CZ121, CZ112, CW614N
              </li>
              <li>
                <strong>Aluminum:</strong> 6061, 6082, EC grade Aluminum
              </li>
              <li>
                <strong>Bronze:</strong> Phosphor Bronze, Gunmetal
              </li>
            </ul>
          </Col>
        </Row>

        <Row className="mb-5">
          <Col>
            <h4>Applications:</h4>
            <ul>
              <li>Switchgear & Electrical Panels</li>
              <li>Railways and Metro Infrastructure</li>
              <li>Transformers and Power Distribution Systems</li>
              <li>HVAC Systems and Building Automation</li>
              <li>Telecom Equipment and Signal Processing</li>
              <li>Automotive Parts and Battery Assemblies</li>
              <li>Control Systems and Industrial Automation</li>
            </ul>
          </Col>
        </Row>

        <Row className="mb-5">
          <Col>
            <h4>Quality & Certifications:</h4>
            <ul>
              <li>
                All parts inspected for tolerance, finish, and performance
              </li>
              <li>ISO 9001:2015 manufacturing process compliant</li>
              <li>RoHS compliant materials</li>
              <li>
                Test reports and compliance certificates available on request
              </li>
            </ul>
          </Col>
        </Row>

        <div className="mt-5">
          <h4 className="mb-4 text-center">Related Products</h4>
          <Row>
            {relatedProducts.map((product, index) => (
              <Col md={3} sm={6} className="mb-4" key={index}>
                <Card className="h-100 shadow-sm">
                  <Card.Img
                    variant="top"
                    src={product.image}
                    alt={product.name}
                    style={{ height: "180px", objectFit: "cover" }}
                  />
                  <Card.Body>
                    <Card.Title>{product.name}</Card.Title>
                    <Card.Text>{product.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </>
  );
};

export default NonFerrousMachinedParts;
